import { asSingleStyleConfig } from '../../utils/theme';
var baseStyle = {
  fontSize: 'md',
  mb: 3,
  fontWeight: 600,
  transition: 'all 0.2s',
  opacity: 1,
  _disabled: {
    color: 'grey.800'
  }
};
export default asSingleStyleConfig({
  baseStyle
});